import type { FundingFunnelEvent } from '@morfi/onramp-sdk';
import type { EventDefinition } from './navigation';

/** Client observations are distinct from canonical backend financial events. */
export type OnrampFunnelProperties = FundingFunnelEvent;
export const ONRAMP_FUNNEL: EventDefinition<OnrampFunnelProperties> = { name: 'onramp_funnel' };
export type ManualTransferProperties = {
  platform: 'web';
  surface: 'manual_transfer';
  network: string;
};
export const ONRAMP_MANUAL_TRANSFER_OPENED: EventDefinition<ManualTransferProperties> = {
  name: 'onramp_manual_transfer_opened',
};
export const ONRAMP_MANUAL_TRANSFER_ADDRESS_COPIED: EventDefinition<ManualTransferProperties> = {
  name: 'onramp_manual_transfer_address_copied',
};
export const ONRAMP_MANUAL_TRANSFER_ALTERNATE_CRYPTO_SELECTED: EventDefinition<ManualTransferProperties> =
  { name: 'onramp_manual_transfer_alternate_crypto_selected' };
